import { Glyphicon } from 'react-bootstrap';
import { useFormContext, useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import Button from 'components/button/Button';
import CheckboxField from 'components/forms/checkboxField/CheckboxField';
import TextField from 'components/forms/textField/TextField';
import useCopyToClipboard from 'hooks/useCopyToClipboard';
import { NavigationSettingsFormValues } from './NavigationSettings.schema';
import {
  NavigationRowActionsStyled,
  NavigationRowStyled,
} from './NavigationSettings.styles';

interface Props {
  index: number;
  onDelete: () => void;
}

const NavigationRow = ({ index, onDelete }: Props) => {
  const { t } = useTranslation();
  const { control } = useFormContext<NavigationSettingsFormValues>();
  const { getCopyAddonIcon } = useCopyToClipboard();

  const url = useWatch({ control, name: `navigation.${index}.url` }) ?? '';

  return (
    <NavigationRowStyled data-testid={`navigation-row-${index}`}>
      <TextField
        colSmInput={12}
        label={t('pageDirectBookingEngine.navigationSettings.navigationTitle')}
        labelOnTop
        name={`navigation.${index}.name`}
        placeholder={t(
          'pageDirectBookingEngine.navigationSettings.titlePlaceholder',
        )}
      />
      <TextField
        colSmInput={12}
        label={t('pageDirectBookingEngine.navigationSettings.navigationLink')}
        labelOnTop
        name={`navigation.${index}.url`}
        placeholder={t(
          'pageDirectBookingEngine.navigationSettings.linkPlaceholder',
        )}
        rightAddons={[getCopyAddonIcon(url)]}
      />
      <CheckboxField name={`navigation.${index}.openLinkInNewTab`}>
        {t('pageDirectBookingEngine.navigationSettings.openInNewTab')}
      </CheckboxField>
      <NavigationRowActionsStyled>
        <Button
          data-testid={`delete-navigation-button-${index}`}
          leftIcon={<Glyphicon glyph="trash" />}
          onClick={onDelete}
        >
          {t('pageDirectBookingEngine.navigationSettings.delete')}
        </Button>
      </NavigationRowActionsStyled>
    </NavigationRowStyled>
  );
};

export default NavigationRow;
